import { render, staticRenderFns } from "./LoginCheckPage.vue?vue&type=template&id=349964fa&scoped=true"
import script from "./LoginCheckPage.vue?vue&type=script&lang=js"
export * from "./LoginCheckPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349964fa",
  null
  
)

export default component.exports